import React, { FC } from 'react';

import classNames from 'classnames';
import { ILoginSocialBarProps, Layout } from '../LoginSocialBar.types';

import { getDataAttributes } from '../../../core/commons/utils';
import styles from './style/LoginSocialBar.scss';
import LoggedInSocialBar from './components/loggedInSocialBar';
import LoggedOffSocialBar from './components/loggedOffSocialBar';
import {
  BIAction,
  getMembersAreaNavigationEvent,
  MEMBERS_APP_UOU_ENDPOINT,
} from './bi/events';

const showAvatar = (displayMode: Layout) =>
  displayMode === Layout.AvatarOnly ||
  displayMode === Layout.AvatarAndText ||
  displayMode === Layout.MemberInitials;

const LoginSocialBar: FC<ILoginSocialBarProps> = props => {
  const {
    id,
    className,
    isLoggedIn,
    userName,
    loggedInText,
    loggedOutText,
    logOutText,
    direction,
    useNativeMenu,
    menuItems,
    iconItems,
    currentPrimaryPageHref,
    onLogin,
    onLogout,
    navigateTo,
    onMouseEnter,
    onMouseLeave,
    isMenuOpen,
    onMenuOpen,
    onMenuClose,
    translate,
    displayMode,
    avatarUri,
    iconSize,
    defaultAvatarSvgContent,
    showBellIcon,
    arrowShape,
    menuItemsAlignment,
    reportBi,
  } = props;

  const showIcons = showBellIcon && !!iconItems.length;

  const onHover = (event: React.MouseEvent<Element, MouseEvent>) => {
    onMouseEnter?.(event);
    if (isLoggedIn && !isMenuOpen) {
      reportBi(getMembersAreaNavigationEvent({ action: BIAction.Hover }), {
        endpoint: MEMBERS_APP_UOU_ENDPOINT,
      });
    }
  };

  const openMenu = () => {
    onMenuOpen();
    if (isLoggedIn) {
      reportBi(getMembersAreaNavigationEvent({ action: BIAction.MenuClick }), {
        endpoint: MEMBERS_APP_UOU_ENDPOINT,
      });
    }
  };

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      className={classNames(className, styles.root)}
      onMouseEnter={onHover}
      onMouseLeave={onMouseLeave}
    >
      {isLoggedIn ? (
        <LoggedInSocialBar
          avatarUri={avatarUri}
          isLoggedIn={isLoggedIn}
          userName={userName}
          id={id}
          displayMode={displayMode}
          iconSize={iconSize}
          defaultAvatarSvgContent={defaultAvatarSvgContent}
          loggedInText={loggedInText}
          currentPrimaryPageHref={currentPrimaryPageHref}
          direction={direction}
          menuItems={menuItems}
          iconItems={iconItems}
          showIcons={showIcons}
          isMenuOpen={isMenuOpen}
          onMenuOpen={openMenu}
          logOutText={logOutText}
          navigateTo={navigateTo}
          onLogout={onLogout}
          onMenuClose={onMenuClose}
          showAvatar={showAvatar(displayMode)}
          useNativeMenu={useNativeMenu}
          translate={translate}
          arrowShape={arrowShape}
          menuItemsAlignment={menuItemsAlignment}
          reportBi={reportBi}
        />
      ) : (
        <LoggedOffSocialBar
          id={id}
          displayMode={displayMode}
          iconSize={iconSize}
          defaultAvatarSvgContent={defaultAvatarSvgContent}
          isLoggedIn={isLoggedIn}
          userName={userName}
          avatarUri={avatarUri}
          loggedOutText={loggedOutText}
          showAvatar={showAvatar(displayMode)}
          handleLogin={onLogin}
          translate={translate}
        />
      )}
    </div>
  );
};

export default LoginSocialBar;
